import { CarouselDesignTokens } from '@primeuix/themes/types/carousel';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/carousel/index.ts
const car = componentCommon.carousel;
const carCs = componentColorScheme.carousel;

export const CarouselTelekomDT: CarouselDesignTokens = {
  content: {
    gap: t(car.content.gap),
  },
  indicatorList: {
    padding: t(car.indicator.list.padding),
    gap: t(car.indicator.list.gap),
  },
  indicator: {
    width: t(car.indicator.width),
    height: t(car.indicator.height),
    borderRadius: t(car.indicator.border.radius),
    focusRing: {
      width: t(car.indicator.focus.ring.width),
      color: t(car.indicator.focus.ring.color),
      offset: t(car.indicator.focus.ring.offset),
    },
    background: t(carCs.indicator.background),
    hoverBackground: t(carCs.indicator.hover.background),
    activeBackground: t(car.indicator.active.background),
  },
};
